import { returnAction } from '../return-action.util';
import { ActionEnum } from '../../../enum/action.enum';
import { IMediaLibraryOpenPayload } from '../../../action/media-library.action';
import { ImageModel } from '../../../model/media-library/image.model';

export const mediaLibraryOpen = (insertFunction: (image: ImageModel) => void) => returnAction<IMediaLibraryOpenPayload>(ActionEnum.MEDIA_LIBRARY_OPEN, {insertFunction});
